'use strict';

function getOfferRedemptionData(data) {
  const {
    offerId,
    offerTitle,
    offerDescription,
    offerType,
    offerCode,
    expiryDateTime,
    termsAndConditions,
    financialTerms,
    isLimitedGlobally,
    isLimitedPerUser,
  } = data;
  const { merchantId, merchantName, merchantMedia } = data.merchant || {};

  return {
    offerId,
    offerTitle,
    offerDescription,
    offerType,
    offerCode,
    expiryDateTime,
    termsAndConditions,
    financialTerms,
    isLimited: isLimitedGlobally || isLimitedPerUser,
    type: 'TERMS',
    merchantId,
    merchantName,
    merchantMedia,
  };
}

function getReferralSource({ referralSource, offerId, directRedemption }) {
  const directOfferId = directRedemption && directRedemption.offerId;

  if (referralSource === 'email' && directOfferId !== offerId) {
    return '';
  }

  return referralSource;
}

function getconquestOffer({ isPremiumOffer, offerMedia, routes, offerId }) {
  const { showConquest } = window.Groupon
    ? window.Groupon.Utils.getConfigFromDom()
    : {};

  const media =
    isPremiumOffer &&
    showConquest &&
    Array.isArray(offerMedia) &&
    offerMedia.find(({ mediaType }) => mediaType === 'PremiumOfferImage');

  return media
    ? {
        offerMedia: media,
        offerUrl: routes.redirect.offers.replace('{offerId}', offerId),
      }
    : null;
}

function getMerchantRedirect({ conquestOffer, routes, merchantId }) {
  if (conquestOffer) {
    return conquestOffer.offerUrl;
  }

  return routes.redirect.merchant.replace('{merchantId}', merchantId);
}

module.exports = {
  getOfferRedemptionData,
  getReferralSource,
  getconquestOffer,
  getMerchantRedirect,
};
